// extracted by mini-css-extract-plugin
export default {"main":"SubLayout_main__pjZSd","bg":"SubLayout_bg__RfXsH","image":"SubLayout_image__Z5d-7","white_line":"SubLayout_white_line__C5ywr"};